import { createReducer } from 'deox';
import produce from 'immer';
import { closeAuthModal, openAuthModal, setForgotText } from './actions';
import { authModalState } from './types';

export const authModalInitialState: authModalState = {
  modalContent: null,
  forgotContentText: '',
};

export const authModalReducer = createReducer(authModalInitialState, (handle) => [
  handle(closeAuthModal, (state, {}: any) =>
    produce(state, (draft) => {
      draft.modalContent = null;
    })
  ),
  handle(openAuthModal, (state, { payload }: any) =>
    produce(state, (draft) => {
      draft.modalContent = payload;
    })
  ),
  handle(setForgotText, (state, { payload }: any) =>
    produce(state, (draft) => {
      draft.forgotContentText = payload;
    })
  ),
]);
